import { createCookie } from 'react-router';
import { supportedLanguages } from "./resource"
import type { InitOptions } from "i18next"
export const localeCookie = createCookie("lng", {
  path: "/",
  sameSite: "lax",
  secure: process.env.NODE_ENV === "production",
  httpOnly: true,
});



export default {
  // This is the list of languages your application supports
  supportedLngs: supportedLanguages,
  // This is the language you want to use in case
  // if the user language is not in the supportedLngs
  fallbackLng: "vi",
  // The default namespace of i18next is "translation", but you can customize it here
  defaultNS: "common",
} satisfies Omit<InitOptions, "react" | "detection">

